import MuiProvider from "../utils/muiProvider";
import { Toaster } from "react-hot-toast";
import { DPadController } from "../components/layout/sidebar";

export const metadata = {
  title: "منه باخ",
  description: "به منه باخ خوش آمدید",
};

export default function RootLayout({ children }) {
  return (
    <MuiProvider>
      <Toaster />
      {children}
      <DPadController />
    </MuiProvider>
  );
}
